module.exports = __webpack_public_path__ + "images/adac010b3f40c74d702213709376290661b3.png";